import React, { Component } from 'react';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css';
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css';
import IntlMessageFormat from 'intl-messageformat';

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') { return; }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$2 = ".stars-module_stars__6uKB1 {\n  display: inline-flex;\n  align-items: baseline;\n  font-size: 1.1em;\n  touch-action: none;\n}\n.stars-module_stars__6uKB1 i.icons {\n  margin-right: 0.33ex;\n}\n@media only screen and (max-width: 599px) {\n  .stars-module_stars__6uKB1 i.icons {\n    font-size: 1.25em;\n    margin-right: 0.5ex;\n  }\n}\n.stars-module_stars__6uKB1 i.icons i.icon:first-child {\n  margin-right: 0;\n}\n.stars-module_stars__6uKB1 i.icons:hover {\n  cursor: pointer;\n}\n.stars-module_stars__6uKB1 i.icons i.icon.invisible {\n  visibility: hidden;\n}\n\n.stars-module_averageLabel__Fviv2 {\n  margin-left: 1.5em;\n  color: var(--light-text-color);\n  font-weight: 300;\n}";
var s$1 = {"stars":"stars-module_stars__6uKB1","averageLabel":"stars-module_averageLabel__Fviv2"};
styleInject(css_248z$2);

function Star(props) {
    var updatedEvents = {};
    Object.entries(props.events).forEach(function (handler) {
        updatedEvents[handler[0]] = function (event) {
            event.stopPropagation();
            handler[1](props.i, event);
        };
    });
    var iconClasses = ['star icon', props.starColor];
    if (props.inverted)
        iconClasses.push('inverted');
    var outlinedIconClasses = iconClasses.concat('outline');
    var filledIconClasses = iconClasses.concat(props.starClass);
    return (React.createElement("i", __assign({ role: 'button', "aria-pressed": props.pressed, tabIndex: 0, "aria-label": props.i + " Sterne", className: 'ui icons' }, updatedEvents),
        React.createElement("i", { className: outlinedIconClasses.join(' ') }),
        React.createElement("i", { className: filledIconClasses.join(' ') })));
}

var DEFAULT_NUMBER_OF_STARS = 5;
var Stars = (function (_super) {
    __extends(Stars, _super);
    function Stars(props) {
        var _this = _super.call(this, props) || this;
        _this.onMouseLeave = function (enteredRating) {
            _this.setState({
                activeStar: -1
            });
        };
        _this.onMouseEnter = function (enteredRating) {
            _this.setState({
                activeStar: enteredRating
            });
        };
        _this.state = {
            activeStar: -1
        };
        return _this;
    }
    Stars.prototype.render = function () {
        var _this = this;
        var starArray = [];
        var additionalHalfStar = false;
        var floorStars = 0;
        var events = {
            onTouchEnd: function (number, event) {
                event.preventDefault();
                _this.props.onSelect(number);
            },
            onClick: this.props.onSelect,
            onKeyDown: function (number, event) {
                switch (event.key) {
                    case ' ':
                    case 'Enter':
                    case 'Spacebar':
                        event.preventDefault();
                        _this.props.onSelect(number);
                        break;
                }
            }
        };
        if (window.matchMedia('(hover: hover)').matches) {
            events = __assign(__assign({}, events), { onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave });
        }
        if (this.props.averageRating) {
            floorStars = Math.floor(this.props.averageRating);
            if (this.props.averageRating &&
                this.props.averageRating - floorStars >= 0.25 &&
                this.props.averageRating - floorStars < 0.75) {
                additionalHalfStar = true;
            }
            if (this.props.averageRating &&
                this.props.averageRating - floorStars >= 0.75) {
                floorStars = floorStars + 1;
            }
        }
        for (var i = 1; i <= (this.props.starAmount || DEFAULT_NUMBER_OF_STARS); i++) {
            var starClass = 'invisible';
            if (this.state.activeStar >= i ||
                this.props.currentlySelectedRating >= i) {
                starClass = '';
            }
            if (this.props.votingIsOver) {
                starClass = 'over';
                if (floorStars < i) {
                    starClass = 'invisible';
                    if (additionalHalfStar && i - 1 === floorStars) {
                        starClass = 'over half';
                    }
                }
            }
            starArray.push(React.createElement(Star, { key: "star-" + i, i: i, inverted: this.props.inverted, events: events, starColor: this.props.starColor, starClass: starClass, pressed: this.props.currentlySelectedRating >= i ||
                    this.state.activeStar >= i }));
        }
        return (React.createElement("a", { className: "stars " + s$1.stars + " " + (this.props.starColor ? this.props.starColor : '') + " " + (this.props.inverted ? 'inverted' : '') },
            starArray,
            this.props.votingIsOver && this.props.averageRating && (React.createElement("span", { className: "label average " + s$1.averageLabel + " " + (this.props.inverted ? 'inverted' : '') },
                "\u2300",
                ' ',
                this.props.averageRating.toLocaleString('fr-CH', {
                    maximumFractionDigits: 1,
                    minimumFractionDigits: 1
                })))));
    };
    Stars.defaultProps = {
        starAmount: DEFAULT_NUMBER_OF_STARS,
        inverted: false,
        currentlySelectedRating: -1,
        votingIsOver: false
    };
    return Stars;
}(Component));

var css_248z$1 = "@media screen and (max-width: 599px) {\n  .question-module_question__A2SNI {\n    margin-bottom: 0.5ex;\n    font-weight: 500 !important;\n  }\n}\n\n.question-module_questionGroup__4eIUC {\n  font-size: var(--font-size);\n}\n@media screen and (max-width: 599px) {\n  .question-module_questionGroup__4eIUC {\n    margin-bottom: 1ex;\n  }\n  .question-module_questionGroup__4eIUC:last-child {\n    margin-bottom: 0;\n  }\n}";
var styles = {"question":"question-module_question__A2SNI","questionGroup":"question-module_questionGroup__4eIUC"};
styleInject(css_248z$1);

var Question = (function (_super) {
    __extends(Question, _super);
    function Question() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentlySelectedRating: -1
        };
        _this.handleClick = function (selectedRating) {
            if (!_this.props.votingIsOver) {
                _this.setState({
                    currentlySelectedRating: selectedRating
                });
                _this.props.ratingHandler(_this.props.question, selectedRating);
            }
        };
        return _this;
    }
    Question.prototype.render = function () {
        return (React.createElement("tr", { className: styles.questionGroup },
            React.createElement("td", { className: styles.question }, this.props.question),
            React.createElement("td", { className: 'single line right aligned' },
                React.createElement(Stars, { averageRating: this.props.averageRating, onSelect: this.handleClick, inverted: this.props.inverted, currentlySelectedRating: this.state.currentlySelectedRating, starAmount: this.props.starAmount, starColor: this.props.starColor, votingIsOver: this.props.votingIsOver }))));
    };
    Question.defaultProps = {
        inverted: false,
        starAmount: 5,
        votingIsOver: false
    };
    return Question;
}(Component));

var css_248z = ".styles-module_userFeedback__DUfjU {\n  --font-size: 0.9rem;\n  font-size: var(--font-size);\n}\n.styles-module_userFeedback__DUfjU .ui.table {\n  background: none !important;\n  margin: 0;\n}\n@media only screen and (max-width: 599px) {\n  .styles-module_userFeedback__DUfjU .ui.table:not(.unstackable) .right.aligned {\n    text-align: left;\n  }\n}\n\n.styles-module_feedbackText__oKWxq,\n.styles-module_mainQuestion__JcMnS {\n  color: var(--text-color);\n  margin-bottom: 0.611em;\n}\n\n.styles-module_feedbackText__oKWxq {\n  margin-bottom: 1ex;\n}\n\n.styles-module_mainQuestion__JcMnS {\n  font-weight: 700;\n  font-size: 1.2em;\n}\n\n@media screen and (max-width: 599px) {\n  .table.inverted tr {\n    padding: var(--vertical-padding) 0 !important;\n  }\n}";
var s = {"userFeedback":"styles-module_userFeedback__DUfjU","feedbackText":"styles-module_feedbackText__oKWxq","mainQuestion":"styles-module_mainQuestion__JcMnS"};
styleInject(css_248z);

var data$2 = { meta:{ forComponent:"UserFeedback",
    language:"German" },
  answerText:"Die meisten Leserinnen und Leser bewerten den Beitrag als sehr gut. Das freut uns.\n",
  questions:[ "Wie informativ war der Beitrag?",
    "Wie unterhaltsam war er?",
    "Wie gefällt Ihnen die Gestaltung?" ],
  title:"Wie wars?",
  feedback:{ thanks:"Vielen Dank für Ihre Bewertung.",
    stats:"Bisher {respondentCount, plural, =0 {hat noch niemand} one {hat <strong>eine Person</strong>} other {haben <strong># Personen</strong>}} abgestimmt.\n" },
  error:{ noSave:"Vielen Dank für Ihre Bewertung! Leider gab es ein Problem mit der Kommunikation mit der Datenbank, und Ihre Bewertung konnte nicht gespeichert werden. Bitte versuchen Sie es später erneut.\n",
    noDownload:"Vielen Dank für Ihre Stimme. Leider konnten die Bewertungen der anderen Leserinnen und Leser nicht heruntergeladen werden. Wir können Ihnen deshalb im Moment die durchschnittliche Bewertung nicht anzeigen.\n" },
  submit:"Bewerten" };
data$2.meta;
data$2.answerText;
data$2.questions;
data$2.title;
data$2.feedback;
data$2.error;
data$2.submit;

var data$1 = { meta:{ forComponent:"UserFeedback",
    language:"French" },
  answerText:"Une majorité de lectrices et lecteurs estime que ce contenu est très bon. Nous en sommes reconnaissants.\n",
  questions:[ "Ce contenu était-il informatif?",
    "Etait-il divertissant?",
    "La mise en forme vous plaît-elle?" ],
  title:"Comment évaluez-vous cette contribution?",
  feedback:{ thanks:"Merci pour votre évaluation.",
    stats:"{respondentCount, plural, =0 {Personne n'a encore} one {<strong>Une personne</strong> a} other {<strong># personnes</strong> ont}} noté ce contenu.\n" },
  error:{ noSave:"Merci beaucoup pour votre évaluation! Malheureusement, la communication avec la base de données n'a pu être établie et vos notes n'ont pu être prises en compte. Nous vous prions de réessayer un peu plus tard.\n",
    noDownload:"Merci beaucoup pour votre évaluation. Malheureusement, les notes des autres utilisateurs n'ont pu être téléchargées. C'est la raison pour laquelle nous ne pouvons pas afficher de moyennes pour le moment.\n" },
  submit:"Confirmer" };
data$1.meta;
data$1.answerText;
data$1.questions;
data$1.title;
data$1.feedback;
data$1.error;
data$1.submit;

var data = { meta:{ forComponent:"UserFeedback",
    language:"English" },
  answerText:"Most readers rate this article as \"Very Good\". Thank you!\n",
  questions:[ "How informative was the article?",
    "How entertaining was it?",
    "How do you like the design?" ],
  title:"How was it?",
  feedback:{ thanks:"Thank you for your rating.",
    stats:"So far, {respondentCount, plural, =0 {no one has} one {<strong>one reader</strong> has} other {<strong># readers</strong> have}} rated this article.\n" },
  error:{ noSave:"Thank you for rating this article. Unfortunately, there has been a problem communicating with the database, and your rating could not be saved. Please try again at a later date.\n",
    noDownload:"Thank you for rating this article. Unfortunately, the ratings of other readers could not be downloaded, and we are currently not able to show you\n the average rating.\n" },
  submit:"Rate" };
data.meta;
data.answerText;
data.questions;
data.title;
data.feedback;
data.error;
data.submit;

var RequestStatus;
(function (RequestStatus) {
    RequestStatus[RequestStatus["ready"] = 0] = "ready";
    RequestStatus[RequestStatus["loading"] = 1] = "loading";
    RequestStatus[RequestStatus["success"] = 2] = "success";
    RequestStatus[RequestStatus["error"] = 3] = "error";
})(RequestStatus || (RequestStatus = {}));

var DB_ENDPOINT = 'https://ta-user-feedback.firebaseio.com/v2/stories';
var MESSAGES = {
    de: data$2,
    fr: data$1,
    en: data
};
var UserFeedback = (function (_super) {
    __extends(UserFeedback, _super);
    function UserFeedback(props) {
        var _this = _super.call(this, props) || this;
        _this.submit = function () {
            _this.setState({ requestStatus: RequestStatus.loading });
            _this.pushVotesToDB(_this.state.personalVotes)
                .then(function (downloadedValues) {
                _this.setVoteResults(downloadedValues);
                _this.setState({
                    votingIsOver: true,
                    requestStatus: RequestStatus.success
                });
            })
                .catch(function (error) {
                console.log(error.message, error);
                _this.setState({
                    requestStatus: RequestStatus.error
                });
            });
        };
        _this.handleClick = function () {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Interactions',
                event_action: 'click',
                event_label: 'region: userVoteButtonClicked/'
            });
            _this.submit();
        };
        _this.ratingHandler = function (question, rating) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'Interactions',
                event_action: 'click',
                event_label: 'region: userVote/' + rating
            });
            _this.setState(function (state) {
                var questionRatings = state.personalVotes;
                var questions = _this.props.questions ||
                    (_this.props.locale &&
                        MESSAGES[_this.props.locale].questions);
                questionRatings[questions.indexOf(question)] = rating;
                return {
                    personalVotes: questionRatings
                };
            }, _this.checkIfSubmitReady);
        };
        var questions = props.questions ||
            (props.locale && MESSAGES[props.locale].questions);
        _this.state = {
            personalVotes: questions.map(function () { return -1; }),
            readyToSubmit: false,
            hasError: false,
            votingIsOver: !!localStorage.getItem('vote-' + _this.props.articleId),
            requestStatus: RequestStatus.ready
        };
        return _this;
    }
    UserFeedback.prototype.pushVotesToDB = function (ratings) {
        var _this = this;
        return fetch(DB_ENDPOINT + "/" + this.props.articleId + ".json", {
            headers: { 'X-Firebase-ETag': 'true' }
        })
            .then(function (originalValueResponse) {
            return originalValueResponse.json().then(function (previousValue) {
                if (!originalValueResponse.ok) {
                    throw Error(originalValueResponse.statusText);
                }
                var etag = originalValueResponse.headers.get('ETag');
                if (!previousValue) {
                    return fetch(DB_ENDPOINT + "/" + _this.props.articleId + ".json", {
                        method: 'PUT',
                        body: JSON.stringify({
                            p: 1,
                            v: ratings
                        })
                    }).then(function (writeResponse) {
                        if (!writeResponse.ok) {
                            throw Error(writeResponse.statusText);
                        }
                        localStorage.setItem('vote-' + _this.props.articleId, JSON.stringify(ratings));
                        return writeResponse.json();
                    });
                }
                return _this.writeToDatabase(ratings, previousValue, etag);
            });
        })
            .catch(function (error) {
            console.log(error.message, error);
            _this.setState({
                hasError: true,
                errorText: 'error.noSave'
            });
            return { p: 1, v: ratings };
        });
    };
    UserFeedback.prototype.writeToDatabase = function (ratings, previousValue, eTag) {
        var _this = this;
        return fetch(DB_ENDPOINT + "/" + this.props.articleId + ".json", {
            headers: eTag ? { 'if-match': eTag } : undefined,
            method: 'PUT',
            body: JSON.stringify(this.updatePreviousValuesWithNewVotes(previousValue, ratings))
        }).then(function (writeResponse) {
            return writeResponse.json().then(function (json) {
                var responseStatus = writeResponse.status;
                if (responseStatus === 412) {
                    var newValue = json;
                    var newEtag = writeResponse.headers.get('ETag');
                    return _this.writeToDatabase(ratings, newValue, newEtag);
                }
                if (responseStatus === 200) {
                    localStorage.setItem('vote-' + _this.props.articleId, JSON.stringify(ratings));
                    return json;
                }
            });
        });
    };
    UserFeedback.prototype.updatePreviousValuesWithNewVotes = function (previousValue, ratings) {
        var cumulativeVotes = previousValue.v.map(function (previousVote, index) { return previousVote + ratings[index]; });
        return {
            p: previousValue.p + 1,
            v: cumulativeVotes
        };
    };
    UserFeedback.prototype.checkIfSubmitReady = function () {
        this.setState(function (state) {
            return { readyToSubmit: state.personalVotes.every(function (value) { return value > 0; }) };
        });
    };
    UserFeedback.prototype.setVoteResults = function (downloadedValues) {
        var averages = downloadedValues.v.map(function (cumulativeVote) { return cumulativeVote / downloadedValues.p; });
        var overallAverage = averages.reduce(function (previousValue, currentValue) { return previousValue + currentValue; }) / averages.length;
        this.setState({
            numberOfParticipants: downloadedValues.p,
            averageVotes: averages,
            overallAverage: overallAverage
        });
    };
    UserFeedback.prototype.componentDidMount = function () {
        var _this = this;
        if (localStorage.getItem('vote-' + this.props.articleId)) {
            this.setState({ requestStatus: RequestStatus.loading });
            return fetch(DB_ENDPOINT + "/" + this.props.articleId + ".json")
                .then(function (response) {
                return response.json().then(function (values) {
                    _this.setVoteResults(values);
                    _this.setState({
                        requestStatus: RequestStatus.success
                    });
                });
            })
                .catch(function (error) {
                console.log(error);
                _this.setState({
                    hasError: true,
                    errorText: 'error.noDownload',
                    requestStatus: RequestStatus.error
                });
                _this.setVoteResults({
                    p: 1,
                    v: JSON.parse(localStorage.getItem('vote-' + _this.props.articleId) || '[]')
                });
            });
        }
    };
    UserFeedback.prototype.render = function () {
        var _this = this;
        var t = function (key) {
            return (_this.props[key] ||
                key
                    .split('.')
                    .reduce(function (messageList, prop) {
                    return Object.prototype.hasOwnProperty.call(messageList, prop)
                        ? messageList[prop]
                        : 'TRANSLATED_STRING_NOT_FOUND: ' + key;
                }, MESSAGES[_this.props.locale || 'de']));
        };
        var buttonClasses = ['ui button', this.props.starColor];
        if (!this.state.readyToSubmit)
            buttonClasses.push('disabled');
        if (this.props.inverted)
            buttonClasses.push('inverted');
        if (this.state.requestStatus === RequestStatus.loading)
            buttonClasses.push('loading');
        var respondentMessage = new IntlMessageFormat(t('feedback.stats'), this.props.locale + '-CH');
        var questions = t('questions');
        return (React.createElement("div", { className: "user-feedback interactive " + s.userFeedback + " " + this.props.className + " " + (this.props.inverted ? 'inverted' : '') },
            this.state.votingIsOver && !this.state.hasError && (React.createElement("div", { className: "feedback-text " + s.feedbackText + " " + (this.props.inverted &&
                    s.inverted) },
                React.createElement("span", null, t('feedback.thanks')),
                ' ',
                React.createElement("span", { dangerouslySetInnerHTML: {
                        __html: respondentMessage.format({
                            respondentCount: this.state.numberOfParticipants
                        })
                    } }),
                ' ',
                this.state.overallAverage &&
                    this.state.overallAverage >=
                        (this.props.starAmount || 5) * 0.8 && (React.createElement("span", null, t('answerText'))))),
            this.state.votingIsOver &&
                this.state.hasError &&
                this.state.errorText && (React.createElement("div", { className: 'feedback-text' }, t(this.state.errorText))),
            !this.state.votingIsOver && (React.createElement("div", { className: "header " + s.mainQuestion + " " + (this.props.inverted ? 'inverted' : '') + " " }, t('title'))),
            React.createElement("table", { id: 'vote-table', className: "ui interactive very basic " + (this.props.inverted ? 'inverted' : '') + " table" },
                React.createElement("tbody", null, questions.map(function (question, i) {
                    var avg = {};
                    if (_this.state.averageVotes) {
                        avg = {
                            averageRating: _this.state.averageVotes[i]
                        };
                    }
                    return (React.createElement(Question, __assign({ ratingHandler: _this.ratingHandler, starAmount: _this.props.starAmount, starColor: _this.props.starColor, question: question, votingIsOver: _this.state.votingIsOver }, avg, { inverted: _this.props.inverted, key: "question-" + i })));
                }))),
            !this.state.votingIsOver && (React.createElement("div", { className: "ui vertical very fitted center aligned " + (this.props.inverted ? 'inverted' : '') + " basic segment" },
                React.createElement("button", { onClick: this.handleClick, className: buttonClasses.join(' ') }, t('submit'))))));
    };
    UserFeedback.defaultProps = {
        className: '',
        inverted: false,
        locale: 'de',
        starAmount: 5,
        starColor: 'primary'
    };
    return UserFeedback;
}(Component));

export { UserFeedback, UserFeedback as default };
//# sourceMappingURL=index.js.map
